import type { BasicMaterial } from "@/types";
import type { Texture } from "three";
import { getTextureAsSrgb } from "./getTextureAsSrgb";

export const processDiceTextures = (
  textures: Record<string, Texture>,
  props?: BasicMaterial,
) => {
  const dissolveTexture =
    textures[props?.dissolveTexture ?? "FALLBACK_DISSOLVE"] ??
    textures["FALLBACK_DISSOLVE"];

  const numberTexture = textures[props?.numberTexture ?? "FALLBACK_PIXEL"];

  let glitterPatternTexture;
  if (props?.glitterPatternTexture && textures[props.glitterPatternTexture]) {
    glitterPatternTexture = getTextureAsSrgb(
      textures[props.glitterPatternTexture],
    );
  }

  return {
    dissolveTexture,
    numberTexture,
    glitterPatternTexture,
  };
};
